// T-75: a Sessions row's own notification level, keyed like the server (session-notification-pref.ts):
// `session:<canonical DM peer id>`, "all" (default) | "muted" (shown as "No notifications").
export const SESSION_SCOPE_PREFIX = "session:";

export type SessionNotificationLevel = "all" | "muted";

export const sessionScopeId = (peerId: string): string => `${SESSION_SCOPE_PREFIX}${peerId}`;

// T-75b "Mute all sessions": the person's one row per workspace, the level of every Sessions row
// without its own. Workspace in the id: this prefs map is flat across workspaces.
export const sessionAllScopeId = (workspaceId: string): string =>
  `${SESSION_SCOPE_PREFIX}*:${workspaceId}`;

/** Own row, else the mute-all row (`allScopeId`, given only for a Sessions row), else all. */
export function sessionLevel(
  prefs: Readonly<Record<string, string>>,
  peerId: string,
  allScopeId?: string,
): SessionNotificationLevel {
  const level = prefs[sessionScopeId(peerId)] ?? (allScopeId ? prefs[allScopeId] : undefined);
  return level === "muted" ? "muted" : "all";
}

export function isSessionSilenced(
  prefs: Readonly<Record<string, string>>,
  peerId: string,
  allScopeId?: string,
): boolean {
  return sessionLevel(prefs, peerId, allScopeId) === "muted";
}
